import golden from "../../img/beecomb.jpg";


export default function WelcomeContainerWeb ({handleShow}) {

    return (
        <div className="welcome-container-web" style={{ backgroundImage: `url(${golden})` }} >

          <div className="sign-up-message">
            <h2 className="fadeIn first title container-title" style={{fontSize:'2.5rem', padding:'0'}} >
              You're one step closer
            </h2>
            <h3 className="fadeIn first title container-title" style={{ padding:'0' }}>
              to earning on your own terms
            </h3>
            <br/>
            <br/>
            <div>
            <p>
              <b>TIPS:</b>  Create a unique screen name that does not include your first or last name.
              <br/><br/>
              <b>Important:</b> A physical address is a requirement of the program, applicants with P.O. boxes will not be considered.
            </p>
            <br/>
            <br/>
            <br/>
            <br/>
            <p>Unsure if you meet the requirements? <a href='https://www.encorehive.com/requirements' style={{color:'var(--orange)', fontWeight:'700'}} >Check Here</a> </p>

            </div>
            

          </div>

          <div className="sign-up-text">
            Already have an account? <a href="#" onClick={handleShow} className="sign-up tx-orange-hover">Sign In</a>
          </div>

        </div>
    )
} 